import './CRUDFirm.scss';
import Component from './CRUDFirm.js';
export default Component;
